import { config } from "src/config/config";

export const isDevelopment = config.APP_ENV === "development";
